require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-runtime/~/core-js/library/fn/number/is-integer.js
// module id = 1257
// module chunks = 0